import { getAppConfig } from 'old/atoms/app-config-gate';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'ui';

export const Footer: FC = () => {
  const { t } = useTranslation();
  const { screens } = getAppConfig();

  return (
    <>
      {process.env.REACT_APP_LANDING_SUMMARY}{' '}
      <a href={screens.terms_screen.link} target="_blank" rel="noopener noreferrer" className="text-hyperlink">
        {t('Terms')}
      </a>{' '}
      &amp;{' '}
      <Link item={{ to: screens.privacy_screen.link, target: '_blank', rel: 'noopener noreferrer' }}>
        {t('Privacy Policy')}
      </Link>
    </>
  );
};
